<template>
    <div>
        <div id="amplate" class="bgTeal" v-if="loggedin">
            <div id="main">
                <div id="branding" :style="{'background-image':'url(' + require('@/assets/artmuseo_bandlogo.svg')+')'}"></div>
                <div id="holder" v-if="!insession">
                    <div id="moderation" class="boxbtn" @click="moderation" v-if="permissions == 'A'">MODERATION</div>
                    <div id="moderation" class="boxbtn" @click="arWindow" v-if="permissions == 'A'">AR APPROVAL</div>
                    <div id="moderation" class="boxbtn" @click="highlights" v-if="permissions == 'A'">HIGHLIGHTS</div>
                    <div id="moderation" class="boxbtn" @click="exhibits" v-if="permissions == 'A'">EXHIBITS</div>
                    <div class="boxbtn" @click="userTool" v-if="permissions == 'A'">USER LOOKUP</div>
                    <!-- <div id="moderation" class="boxbtn" @click="betainvites">BETA INVITES</div> -->
                    <div id="moderation" class="boxbtn" @click="verified" v-if="permissions == 'A'">VERIFICATIONS</div>
                    <div id="moderation" class="boxbtn" @click="listings" v-if="permissions == 'A'">LISTINGS</div>
                    <div id="moderation" class="boxbtn" @click="salesReports">SALES</div>
                    <div id="moderation" class="boxbtn" @click="upsLabels" v-if="permissions == 'A'">UPS LABELS</div>
                    <div id="moderation" class="boxbtn" @click="invoice" v-if="permissions == 'A'">INVOICE</div>
                    <div id="moderation" class="boxbtn" @click="museumEvents" v-if="permissions == 'A'">MUSEUM EVENTS</div>
                    <div id="moderation" class="boxbtn" @click="policyUpdate" v-if="permissions == 'A'">POLICIES</div>
                    <div id="signout" class="amWhiteregular" @click="signoff" v-if="permissions == 'A'">SIGN OUT</div>
                </div>

                <div id="holder2" v-if="insession">
                    <div id="close" class="cpointer" @click="close">*back</div>
                    <mod v-if="inmoderation"></mod>
                    <beta v-if="inbetainvtes"></beta>
                    <exhibit v-if="inexhibits"></exhibit>
                    <listings v-if="inlistings"></listings>
                    <arReady v-if="inAR"></arReady>
                    <labels v-if="inUPS"></labels>
                    <verify v-if="inVerify"></verify>
                    <invoice v-if="inInvoice"></invoice>
                    <sales class="fullScreen" v-if="inSales" :permissions="permissions"></sales>
                    <museums class="fullScreen" v-if="inMuseum"></museums>
                    <highlights class="fullScreen" v-if="inHighlights"></highlights>
                    <policy class="fullScreen" v-if="inPolicy"></policy>
                    <usertool class="fullScreen" v-if="inUsers"></usertool>
                </div>
            </div>
        </div>
        <div id="amplate" v-if="!loggedin">
        <div id="login" v-if="!didSubmit">
            <div id="loginblock" v-if="!authpassed">
          <form @submit.prevent="pressed">
            <div class="boxspacer">
              <div class="tffield2">
                <input
                  id="email"
                  v-model="email"
                  class="emailbox"
                  type="email"
                  placeholder="enter email address"
                  @change="inputStart"
                />
              </div>
            </div>
            <div class="boxspacer">
              <div class="tffield2">
                <input
                  id="password"
                  v-model="password"
                  class="emailbox"
                  type="password"
                  placeholder="password"
                />
              </div>
            </div>
            <div class="tffield2">
              <button class="submitbtn" type="submit">log in</button>
            </div>
          <div id="errorfield" v-if="error">{{errormessage}}</div>
          </form>
        </div>
        <!-- <div id="loginblock" v-if="authpassed">
            <input id="email" v-model="key" class="emailbox" type="password" placeholder="enter secret key">
            <button class="submitbtn" type="submit" @click="submitKey">submit</button>
        </div> -->
        </div>
        </div>
    </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
// import db from '../main'
import mod from '../components/moderation'
import beta from '../components/betainvites'
import exhibits from '../components/exhibits'
import listings from '../components/listings'
import arReady from '../components/arReady'
import upslabels from '../components/upslabels'
import sales from '../components/sales'
import verify from '../components/amVerify'
import invoice from '../components/amInvoice'
import museums from '../components/museums'
import highlights from '../components/highlights'
import policy from '../components/policies'
import usertool from '../components/usertool'
export default {
    name: "a14344",
    data(){
        return {
            loggedin: false,
            insession: false,
            inmoderation: false,
            inbetainvtes: false,
            inexhibits: false,
            inlistings: false,
            inHighlights: false,
            inSales: false,
            inUPS: false,
            inAR: false,
            inVerify: false,
            insales: false,
            inInvoice: false,
            inMuseum: false,
            inPolicy: false,
            inUsers: false,
            userID: "",
            email: "",
            password: "",
            error: false,
            errorcode: false,
            errormessage: null,
            authpassed: false,
            permissions: "",
            key: "",
            didSubmit: false
        }
    },
    methods: {
        signoff(){
            this.didSubmit = false
            firebase.auth().signOut().then(() => this.loggedin = false)
        },
        close(){
            this.insession = false
            this.inmoderation = false
            this.inbetainvtes = false
            this.inexhibits = false
            this.inlistings = false
            this.inUPS = false
            this.inAR = false
            this.inSales = false
            this.inVerify = false
            this.inInvoice = false
            this.inMuseum = false
            this.inHighlights = false
            this.inPolicy = false
            this.inUsers = false
        },
        policyUpdate(){
            this.insession = true
            this.inmoderation = false
            this.inbetainvtes = false
            this.inexhibits = false
            this.inlistings = false
            this.inUPS = false
            this.inAR = false
            this.inSales = false
            this.inVerify = false
            this.inInvoice = false
            this.inMuseum = false
            this.inHighlights = false
            this.inPolicy = true
            this.inUsers = false
        },
        moderation(){
            this.insession = true
            this.inmoderation = true
            this.inbetainvtes = false
            this.inexhibits = false
            this.inlistings = false
            this.inUPS = false
            this.inAR = false
            this.inSales = false
            this.inVerify = false
            this.inInvoice = false
            this.inMuseum = false
            this.inHighlights = false
            this.inPolicy = false
            this.inUsers = false
        },
        userTool(){
            this.insession = true
            this.inmoderation = false
            this.inbetainvtes = false
            this.inexhibits = false
            this.inlistings = false
            this.inUPS = false
            this.inAR = false
            this.inSales = false
            this.inVerify = false
            this.inInvoice = false
            this.inMuseum = false
            this.inHighlights = false
            this.inPolicy = false
            this.inUsers = true
        },
        highlights(){
            this.insession = true
            this.inmoderation = false
            this.inbetainvtes = false
            this.inexhibits = false
            this.inlistings = false
            this.inUPS = false
            this.inAR = false
            this.inSales = false
            this.inVerify = false
            this.inInvoice = false
            this.inMuseum = false
            this.inPolicy = false
            this.inHighlights = true
            this.inUsers = false
        },
        verified(){
            this.insession = true
            this.inmoderation = false
            this.inbetainvtes = false
            this.inexhibits = false
            this.inlistings = false
            this.inUPS = false
            this.inAR = false
            this.inSales = false
            this.inVerify = true
            this.inInvoice = false
            this.inPolicy = false
            this.inMuseum = false
            this.inHighlights = false
            this.inUsers = false
        },
        exhibits(){
            this.insession = true
            this.inmoderation = false
            this.inbetainvtes = false
            this.inexhibits = true
            this.inlistings = false
            this.inUPS = false
            this.inAR = false
            this.inPolicy = false
            this.inSales = false
            this.inInvoice = false
            this.inVerify = false
            this.inMuseum = false
            this.inHighlights = false
            this.inUsers = false
        },
        listings(){
          this.insession = true
          this.inmoderation = false
          this.inbetainvtes = false
          this.inexhibits = false
          this.inlistings = true
          this.inUPS = false
          this.inAR = false
          this.inPolicy = false
          this.inSales = false
          this.inVerify = false
          this.inInvoice = false
          this.inMuseum = false
          this.inHighlights = false
          this.inUsers = false
        },
        betainvites(){
            this.insession = true
            this.inmoderation = false
            this.inbetainvtes = true
            this.inexhibits = false
            this.inlistings = false
            this.inPolicy = false
            this.inUPS = false
            this.inAR = false
            this.inSales = false
            this.inVerify = false
            this.inInvoice = false
            this.inMuseum = false
            this.inHighlights = false
            this.inUsers = false
        },
        arWindow(){
            this.insession = true
            this.inmoderation = false
            this.inbetainvtes = false
            this.inexhibits = false
            this.inlistings = false
            this.inAR = true
            this.inUPS = false
            this.inSales = false
            this.inVerify = false
            this.inInvoice = false
            this.inMuseum = false
            this.inHighlights = false
            this.inPolicy = false
            this.inUsers = false
        },
        upsLabels(){
            this.insession = true
            this.inmoderation = false
            this.inbetainvtes = false
            this.inexhibits = false
            this.inlistings = false
            this.inAR = false
            this.inUPS = true
            this.inVerify = false
            this.inSales = false
            this.inInvoice = false
            this.inMuseum = false
            this.inHighlights = false
            this.inPolicy = false
            this.inUsers = false
        },
        invoice(){
            this.insession = true
            this.inmoderation = false
            this.inbetainvtes = false
            this.inexhibits = false
            this.inlistings = false
            this.inAR = false
            this.inUPS = false
            this.inVerify = false
            this.inSales = false
            this.inInvoice = true
            this.inMuseum = false
            this.inHighlights = false
            this.inPolicy = false
            this.inUsers = false
        },
        salesReports(){
            this.insession = true
            this.inmoderation = false
            this.inbetainvtes = false
            this.inexhibits = false
            this.inlistings = false
            this.inAR = false
            this.inUPS = false
            this.inSales = true
            this.inVerify = false
            this.inInvoice = false
            this.inMuseum = false
            this.inPolicy = false
            this.inHighlights = false
            this.inUsers = false
        },
        museumEvents(){
            this.insession = true
            this.inmoderation = false
            this.inbetainvtes = false
            this.inexhibits = false
            this.inlistings = false
            this.inAR = false
            this.inUPS = false
            this.inSales = false
            this.inVerify = false
            this.inInvoice = false
            this.inMuseum = true
            this.inHighlights = false
            this.inPolicy = false
            this.inUsers = false
        },
        async pressed() {
      try {
        const user = await firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password);
       // console.log('useeeee==>>', user);
       if (user){
        const userCheck = firebase.auth().currentUser.uid
        this.userID = userCheck
        this.didSubmit = true

        const checkAdmin = firebase.functions().httpsCallable('adminCheck')
        checkAdmin({uid:userCheck}).then(result => {
            console.log('result is...', result.data)
            if (result.data !== 'error'){
                console.log(result, result.data)
                console.log('result is...', result.data)
                this.permissions = result.data
                this.loggedin = true
            } else {
                firebase.auth().signOut().then(()=> this.$router.push('/'))
            }

        })
        // this.authpassed = true
        // console.log(this.userID)
        // this.loggedin = true
       }
      } catch (err) {
       // console.log('err===>>>', err);
        this.error = true;
        this.errormessage = err.message;
        this.email = ""
        this.password = ""
      }
        },
        inputStart (){
        this.error = false
        this.errorcode = false
    },
    // submitKey(){
    //     db.collection("amkey").doc(this.key).get().then(snapshot =>{
    //         if (snapshot){
    //             const keys = snapshot.data()
    //             if (this.userID == keys.A1){
    //                 this.loggedin = true
    //                 this.permissions = keys.A2
    //             } else {
    //                 firebase.auth().signOut().then(()=> this.$router.go())
    //             }
    //         }
    //     })
    // }
    },

    components: {
        'mod': mod,
        'beta': beta,
        'exhibit': exhibits,
        'listings': listings,
        'arReady': arReady,
        'labels':upslabels,
        'sales':sales,
        'verify':verify,
        'invoice':invoice,
        'museums':museums,
        'highlights':highlights,
        'policy':policy,
        'usertool':usertool
    }
}
</script>

<style scoped>
        .bgWhiteSmoke { background-color: whitesmoke; }
        .bgTeal { background-color: #00a89d; }
        .bgMint { background-color: #A9D9C2; }
        .bgPink { background-color: #E4A39A; }
        .bgGreen { background-color: #1F524E; }
        .bgGray { background-color: gray; }
.fullScreen {
  width: 100vw;
  height: 100vh;
  background-color: white;
  position: fixed;
  top: 0;
  left: 0;
  overflow: scroll;
}
#amplate {
    width: 100vw;
    height: 100vh;
    position: fixed;
}

#main {
    width: 80vw;
    height: 80vh;
    margin-left: auto;
    margin-right: auto;
    margin-top: 10vh;
}

#holder {
    width: 100%;
    display: flex; 
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
}

.boxbtn {
    width: 25%;
    height: 10%;
    background-color: white;
    padding: 2vh;
    overflow: hidden;
    opacity: 0.9;
    font-family: 'cocomatpro-regular';
    font-size: 1.5em;
    /* line-height: 5.5em; */
    margin-bottom: 2vh; 
    z-index: 8;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

#branding {
    width: 100%;
    height: 6vh;
    background-position: center center;
    background-repeat: no-repeat;
    margin: 5%;
}

#close {
    width: auto;
    padding: 1%;
    text-align: right;
    background-color: #00a89d;
    position: fixed;
    color: white;
    z-index: 100;
    right: 0;
    top: 0;
    margin-right: 20px;
    margin-top: 20px;
}

.boxbtn:hover {
    background-color: turquoise;
    opacity: .5;
}

.submitbtn {
        width: 100%;
        height: 30px;
        background-color: aquamarine;
        border-style: hidden;
        cursor: pointer;
      }

      .emailbox {
        width: 100%;
        height: 50px;
        background-color: whitesmoke;
        border-color: aliceblue;
        border-style: hidden;
        text-align: center;
      }

      #errorfield {
        width: 100%;
        height: 20px;
        clear: right;
        float: left;
        font-family: "cocomatpro-light";
        font-size: .5em;
        margin-bottom: 4%;
        margin-top: -4%;
      }

      #loginblock {
        padding-top: 5%;
        padding-bottom: 1%;
        width: 20%;
        height: auto;
        margin-left: auto;
        margin-right: auto;
        /* margin-bottom: 20px; */
      }

        .tffield2 {
        width: 100%;
        height: 50px;
        clear: right;
        float: left;
        font-family: "cocomatpro-light";
        font-size: 1.15em;
        margin-bottom: 2%;
      }

</style>